<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/coco-call/feature/summary.jpg'"
        :altText="`コードレス呼出しチャイムのコココール`"
        :headerText="
          `呼び出しを確実に伝えてくれるコードレス・チャイム・システム`
        "
        :detailText="
          `受信表示機の表示窓に角度がついているので番号が見やすくなっています。防水構造で衝撃にも強い送信機は、
          豊富な機能で業務を強力にサポートします。`
        "
        :color="'blue'"
      />

      <div class="feature-title">
        安心してご利用いただける 4 つの特徴
      </div>

      <div class="feature-contents">
        <div class="feature-content" style="margin-top: 0;">
          <content-header
            headingTitle="1"
            headingTitleRadius="0"
            title="ノイズ対策にも配慮した安心の小電力タイプ"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <img
            v-lazy="'/static/products/coco-call/feature/feature_01.png'"
            style="top: -50px; width: 35%; height: auto;"
          />
          <div style="width: 70%;">
            <p>
              広い範囲にも対応できる特定小電力タイプを採用。
            </p>
            <p>
              ノイズ対策にも配慮し、さまざまなエリアで安心してご利用いただくことが可能です。
            </p>
          </div>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="2"
            headingTitleRadius="0"
            title="LED 照明の影響を受けにくい安心設計"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            従来の LED( 発光ダイオード )
            照明で発生する電磁波の影響により、ワイヤレス機器は通信トラブルを起すことが少なくありませんでした。
          </p>
          <p>
            コココールはこの問題をクリア。安心してご利用いただけます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="3"
            headingTitleRadius="0"
            title="安心の混信 / 誤作動の防止機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            チャンネル変更するだけで混線を防止できるので、近隣でコココールが使用されていても安心して利用できます。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="4"
            headingTitleRadius="0"
            title="停電にも安心のバックアップ機能"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <p>
            万が一の停電時も、記録された呼出し番号や各種設定をしっかりと記憶しています。
          </p>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">主な機能</h2>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <content-header
              headingTitle="受信表示機"
              headingTitleRadius="0"
              title="角度がついて表示も見やすく、電波の強度も表示機から確認することができます。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />

            <div class="functions">
              <img
                v-lazy="'/static/products/coco-call/feature/function_01.png'"
                style="width: 40%; height: 100%;"
                :style="this.$isPC ? '' : 'width: 100%;'"
              />

              <div class="function">
                <div style="width: 60%; display: inline-block;">
                  <div class="function-title">
                    見やすさがアップ！
                  </div>
                  <div class="function-detail">
                    下向設計の表示窓を採用することで数字をより大きく表示。<br />
                    壁への設置でも下から見やすくなりました。
                  </div>
                </div>
                <img
                  v-lazy="'/static/products/coco-call/feature/function_02.png'"
                  style="width: 35%; display: inline-block;"
                />
              </div>

              <div class="function">
                <div class="function-title">
                  先着順番号表示
                </div>
                <div class="function-detail">
                  受信表示機のディスプレイには、呼び出した送信機の番号を先着順で表示。<br />
                  対応する順番をしっかり把握できます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  かんたん設定を実現
                </div>
                <div class="function-detail">
                  呼び出し番号やチャイム音などを送信機側で簡単に設定することが可能になりました。使い方に合わせて、最適な設定で使用することができるので、サービスを効率よく提供できます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  急ぎの呼び出しがスグわかる
                </div>
                <div class="function-detail">
                  同じ送信機からの呼び出しを複数回キャッチすると、受信表示機の表示番号は点灯表示から点滅表示に変化します。<br />
                  早く対応した方がよい番号がひと目でわかるので大変便利です。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  受信毎にチャイム音の有無を設定
                </div>
                <div class="function-detail">
                  受信表示機は、送信機からの信号受信毎にチャイム音の有無を設定することが可能。あらかじめチャイム音に関するルールを設定しておくことで、効率の良いサービスを行えます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  対応遅れを予防する、経過時間お知らせ機能
                </div>
                <div class="function-detail">
                  表示されている呼び出し番号は、一定時間が経過すると点滅表示となります。<br />
                  さらに、時間の経過に伴い点滅するスピードが4段階で変化していきます。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  電波の状態を目視で確認可能
                </div>
                <div class="function-detail">
                  受信表示機に、送信機からの電波強度表示機能（数字表示）を搭載。送信機を実際のテーブルに置いてテストを実施し、電波が届きにくい場所は事前に対策を行うことで安心して運用することが可能です。
                </div>
              </div>

              <div class="function">
                <div class="function-title">
                  多彩な取付スタイルに対応
                </div>
                <div class="function-detail">
                  本体内に収納できるタイプの吊下げ用フックを標準で装備。<br />
                  天井吊下げや壁取付、台置きなど、受信表示機を最も見やすい場所に、しっかりと確実に設置することが可能になっています。
                </div>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="携帯受信機"
              headingTitleRadius="0"
              title="持ちやすさと操作のしやすさを両立。見やすさにもこだわった携帯タイプの受信表示機。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />
            <div style="display: flex; justify-content: space-between;">
              <img
                v-lazy="'/static/products/coco-call/feature/function_03.png'"
                style="width: 15%; height: 100%;"
              />
              <div class="vertical-functions">
                <div class="function">
                  <div class="function-title">
                    呼び出しをわかりやすくお知らせ
                  </div>
                  <div class="function-detail">
                    呼び出し受信時にはチャイム音とバイブレーション（振動）でお知らせ。<br />
                    また、呼び出しを受信すると番号表示と同時に受信ランプが点滅。呼び出しをわかりやすくお知らせします。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    2窓3色表示
                  </div>
                  <div class="function-detail">
                    2か所からの呼び出しもしっかり表示。それ以上の呼び出しがあった場合にはメモリに記録し、順次表示します。<br />
                    また 3 色の LED により表示番号の色分け表示を実現。<br />
                    それぞれの色と場所を関連づけておくことにより、どこから呼び出されたかがひと目で把握できます。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    連続待受30時間＆約6時間でフル充電
                  </div>
                  <div class="function-detail">
                    バッテリーロングライフ設計により、連続待受時間30時間（イヤホンを使用しない時）を実現。<br />
                    携帯受信表示機のフル充電に掛かる時間は約6時間です。<br />
                    <span style="font-size: 11px;">
                      ※連続待受時間は、電波を正常に受信できる静止状態での平均的な利用時間です。<br />
                      &nbsp;&nbsp;&nbsp;充電状態・気温などの使用環境、利用場所の電波状態などによっては、ご利用時間が短くなることがあります。
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="送信機"
              headingTitleRadius="0"
              title="送信機は丸型、スタンダード型、カード型もご用意しています！"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />

            <div style="display: flex; justify-content: space-between;">
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_07.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">丸型</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_08.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">丸型ナプキン付</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_09.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">スタンダード型</p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_10.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">
                  スタンダード<br />ナプキンスタンド型
                </p>
              </div>
              <div style="width: 19%;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_11.png'"
                  style="width: 100%; background-color: white; border: 1px solid rgb(145, 162, 170);"
                />
                <p style="margin: 0; font-size: 14px;">カード型</p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <content-header
              headingTitle="中継機"
              headingTitleRadius="0"
              title="より広い場所でご利用いただくことが可能になります。"
              withBorder="true"
              fontColor="black"
              borderColor="blue"
            />
            <div style="display: flex; justify-content: space-between;">
              <div style="width: 60%; text-align: center;">
                <img
                  v-lazy="'/static/products/coco-call/feature/function_12.png'"
                  style="width: 100%; height: auto;"
                />
                <p
                  style="margin: 0; color: rgb(16, 106, 203); font-weight: bold;"
                >
                  数値で電波の強度が簡単に確認できます
                </p>
              </div>

              <div class="vertical-functions">
                <div class="function">
                  <div class="function-title">
                    信号の到達範囲を拡大
                  </div>
                  <div class="function-detail">
                    中継機の利用で、信号の到達範囲を拡大することが可能。より広い場所でご利用いただくことが可能になります。
                  </div>
                </div>
                <div class="function">
                  <div class="function-title">
                    同一チャンネルで複数の中継機を設置可能
                  </div>
                  <div class="function-detail">
                    広いエリアで通信を行うことが可能。また入り組んだ施設内等でも、電波を遮る壁などを避けるように中継機を設置することで、安心して通信が行えます。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          お客様を待たせていることがすぐにわかる
        </h3>
      </div>
      <img
        style="width: 100%;max-width: 850px;"
        src="/static/columns/51/img-keepscustomers-waiting-cashregister3-3.png"
        alt="コココール"
      />
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/55">
          <div class="use-scene-block-header">
            試着室からの呼び出しに気付けないなら呼び出しベル導入がおすすめ
          </div>
        </router-link>
        <p>
          試着室からの呼び出しに気付けない場合は、音だけでなく光や振動でも呼び出せる
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/52">
          <div class="use-scene-block-header">
            オフィスで簡単に人を呼び出したいときに使える呼び出しベルとは
          </div>
        </router-link>
        <p>
          受付に来たお客様を待たせてしまったり、商談中に離席して人を呼び出す状況が発生したりしている場合、呼び出しベルを活用するのがおすすめです。オフィス向きの呼び出しベルの選び方を解説します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/51">
          <div class="use-scene-block-header">
            レジでお客様を待たせてしまう悩みを解決する呼び出しベルとは
          </div>
        </router-link>
        <p>
          スタッフがレジから離れている際にお客様に気付かず、待たせてしまうという課題を抱えているなら、呼び出しベルの導入がおすすめです。レジ待ち解消に効果的な呼び出しベルについて詳しく紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/54">
          <div class="use-scene-block-header">
            「先生を呼びたいけど近くにいない」という悩みを解決する呼び出しベル
          </div>
        </router-link>
        <p>
          「先生を呼びたいけど近くにいない」と悩んでいる生徒を抱える学習塾や教育機関向けに、使いやすい呼び出しベルを紹介します。質問しやすい環境を作りたい方は、ぜひ参考にしてください。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'送信機からの呼出しを離れた場所でも確認できますか？'"
        :answer="
          `携帯電話サイズの携帯受信表示機をラインナップ。離れた場所や移動中でも呼び出しを受けることが可能になりました。スタッフが常に携帯受信表示機を携帯することで、よりタイムリーな対応が行なえます。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'どの送信機から呼び出しがあったのか解りますか？'"
        :answer="
          `受信表示機のディスプレイには、呼び出した送信機の番号を先着順で表示します。また、送信機ごとにチャイム音（13種類の中から1つのチャイム音）を設定することも可能です。`
        "
      />
      <question-and-answer
        :number="3"
        :question="'停電になった場合は、呼出し番号は消えてしまいますか？'"
        :answer="
          `安心のバックアップ機能で万が一の停電時も、記録された呼出し番号や各種設定をしっかりと記憶しています。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/3" target="_blank"
            ><img
              src="/static/columns/14/factory_mv.png"
              alt="工場の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/3" target="_blank"
              >工場の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/5" target="_blank"
            ><img
              src="/static/columns/5/img_nursecall_easytopush1.jpg"
              alt="ナースコールを押しやすい環境づくりの方法を5パターンに分けて解説"
          /></a>

          <h3>
            <a href="/column/5" target="_blank"
              >ナースコールを押しやすい環境づくりの方法を5パターンに分けて解説</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/8" target="_blank"
            ><img
              src="/static/columns/8/img_factory_trouble_improvement1.jpg"
              alt="業務・環境改善で工場トラブルを減らす！代表的なトラブルと対処法も"
          /></a>

          <h3>
            <a href="/column/8" target="_blank"
              >業務・環境改善で工場トラブルを減らす！代表的なトラブルと対処法も</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data() {
    return {
      productName: 'coco-call',
      useType: 2,
      items: [
        {
          name: '受信表示機',
          imagePath: '/static/products/coco-call/items/item_01.png',
          spec: {
            型式: 'CC-100B（ブラック）、CC-100S（シルバー）',
            サイズ: '600（W）×66.3（D）×119（H）mm',
            重量: '約 1,320g（コード含む）',
            電源: 'AC100V',
            消費電力: '約 15W',
            受信周波数: '426.025MHz ～（特定小電力）',
            受信方式: '単信方式',
            受信距離: '約 100m（使用環境により変わります）',
            表示方式: '2 桁 5 窓　着信順 1 色表示　設定番号表示',
            チャイム音: '13 種類ロータリー設定',
            音量調節: '10 段階',
            スピーカー出力: '300mW',
            'LED 輝度調節': '10 段階',
            チャンネル: '1 ～ 15 チャンネル',
            電波強度表示機能: '有（設置時に便利）右端窓に表示',
            configDisplay: `右端窓に表示
            （音量・輝度・受信音色が何番目か）`,
            自動消去: `10 秒単位で設定可能
            MAX 990 秒（16 分 30 秒）`,
            メモリ数: '表示を含めて 100 件',
            使用温度: '0℃～ 40℃',
          },
          priceName: `受信表示機
          カラー：ブラック（CC-100B）
          シルバー（CC-100S）`,
          listPrice: 140000,
          regularPrice: 95000,
        },
        {
          name: '消去機＆設定機',
          imagePath: '/static/products/coco-call/items/item_02.png',
          spec: {
            型式: 'CC-400',
            サイズ: '245（W）×80（D）×25（H）mm',
            重量: '約 230g（単三アルカリ乾電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            送信出力: '1mW',
            送信時動作: '5kHz の電子音（ピッ）',
            設定: '音量・表示輝度・自動消去時間・音色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `消去 & 設定器機 白（CC-400）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '卓上丸型送信機',
          imagePath: '/static/products/coco-call/items/item_05.png',
          spec: {
            型式: 'F-305',
            サイズ: '80（W）×80（D）×43（H）mm',
            重量: '約 130g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: `送信機 丸型 1 ボタン（F-305)`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: '卓上丸型送信機 ナプキンスタンド型',
          imagePath: '/static/products/coco-call/items/item_06.png',
          spec: {
            型式: 'F-305N',
            サイズ: '99（W）×129（D）×99（H）mm',
            重量: '約 260g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1 ～ FF',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: `送信機 丸型ナプキン付 1 ボタン
          （F-305N)`,
          listPrice: 15000,
          regularPrice: 10500,
        },
        {
          name: 'スタンダード型送信機',
          imagePath: '/static/products/coco-call/items/item_07.png',
          imageHeight: 300,
          spec: {
            型式: 'F-301',
            サイズ: '85（W）×78（D）×71（H）mm',
            重量: '約 150g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'スタンダード型送信機',
          imagePath: '/static/products/coco-call/items/item_16.png',
          priceName: `送信機 スタンダード型 2 ボタン
          （F-301)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: 'ナプキンスタンド型送信機',
          imagePath: '/static/products/coco-call/items/item_08.png',
          imageHeight: 300,
          spec: {
            型式: 'F-303',
            サイズ: '99（W）×120（D）×111（H）mm',
            重量: '約 240g（単三アルカリ電池 ×2 本含む）',
            電源: '単三アルカリ電池 ×2 本',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'ナプキンスタンド型送信機',
          imagePath: '/static/products/coco-call/items/item_17.png',
          priceName: `送信機 ナプキンスタンド型
          2 ボタン（F-303)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 15000,
          regularPrice: 10500,
        },
        {
          name: 'カード型送信機',
          imagePath: '/static/products/coco-call/items/item_09.png',
          imageHeight: 300,
          spec: {
            型式: 'F-302',
            サイズ: `55（W）×93（D）×11（H）mm
            （ホルダー装着時は 60(W)x98(D)x15(H)mm）`,
            重量: `約 35g（アルカリボタン電池 ×2 個含む。
            ホルダー装着時は約 55g）`,
            電源: 'アルカリボタン電池 LR44×2 個',
            送信周波数: '426.025MHz ～（特定小電力）',
            充電方式: '単信方式',
            送信出力: '1mW',
            チャイム音設定: 'ディップスイッチにて 13 種類',
            送信時動作: '5kHz の電子音（ピッ）/LED 点灯',
            番号設定: '1～FF',
            表示色設定: '各ボタン 3 色',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          comment: `※電池交換時期お知らせ機能付きです。
          ※音色設定が出来ます`,
          priceName: ``,
          listPrice: 0,
          regularPrice: 0,
        },
        {
          name: 'カード型送信機',
          imagePath: '/static/products/coco-call/items/item_18.png',
          priceName: `送信機 カード型ホルダー付
          2 ボタン（F-302)
          カラー：ブラウンアッシュ、
          メタリック、アイボリー`,
          listPrice: 12000,
          regularPrice: 8400,
        },
        {
          name: '携帯受信表示機',
          imagePath: '/static/products/coco-call/items/item_10.png',
          spec: {
            型式: 'F-200',
            サイズ: '51（W）×129（D）×21（H）mm',
            重量: '110g（電池パック含む）',
            電源: '充電バッテリー（リチウムイオンポリマー）',
            送信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            '送信出力（消去時）': '1mW',
            送信時動作: '5kHz の電子音（ピッ）',
            表示方式: '2 桁 2 窓　着信順 3 色表示',
            メモリ記憶数: '50 件',
            充電時間: '約 6 時間',
            待受時間: '約 30 時間（使用環境により変わります）',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `携帯受信表示機（F-200)
          専用ストラップ・イヤホン付
          カラー：メタリック、ブラック`,
          listPrice: 45000,
          regularPrice: 31500,
        },
        {
          name: '充電器 5台用',
          imagePath: '/static/products/coco-call/items/item_11.png',
          spec: {
            型式: 'F-705',
            サイズ: '79（W）×165（D）×54（H）mm',
            重量: '約 400g',
            電源: 'DC6V 専用アダプター',
            充電時間: '約 6 時間',
            充電方式: '接点充電',
            セパレーツ式: '収納部セパレート方式（掃除可能）',
            消費電力: '約 12W（ピーク時）',
          },
          priceName: `充電器 5 台タイプ（F-705）`,
          listPrice: 25000,
          regularPrice: 17500,
        },
        {
          name: '充電器 10台用',
          imagePath: '/static/products/coco-call/items/item_12.png',
          spec: {
            型式: 'F-710',
            サイズ: '79（W）×290（D）×54（H）mm',
            重量: '約 550g',
            電源: 'DC6V 専用アダプター',
            充電時間: '約 6 時間',
            充電方式: '接点充電',
            セパレーツ式: '収納部セパレート方式（掃除可能）',
            消費電力: '約 24W（ピーク時）',
          },
          priceName: `充電器 10 台タイプ（F-710）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '中継機',
          imagePath: '/static/products/coco-call/items/item_13.png',
          spec: {
            型式: 'F-500',
            サイズ: `170（W）×85（D）×40（H）mm
            （アンテナ部含まず）`,
            重量: '約 200g',
            電源: 'DC6V 専用アダプター',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            送信出力: '1mW',
            チャンネル: '1 ～ 15 チャンネル',
            中継機番号設定: '1 ～ 15',
            使用温度: '0℃～ 40℃',
          },
          priceName: `中継機（F-500）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '受信スピーカー',
          imagePath: '/static/products/coco-call/items/item_14.png',
          spec: {
            型式: 'F-600',
            サイズ: `166（W）×82（D）×42（H）mm
            （アンテナ部含まず）`,
            重量: '約 225g',
            電源: 'DC6V 専用アダプター',
            送受信周波数: '426.025MHz ～（特定小電力）',
            送受信方式: '単信方式',
            受信距離: '約 100m（使用環境により変わります）',
            鳴動回数設定: 'ディップスイッチにて 8 種類',
            音量調節: '回転式ボリューム（無段階）',
            スピーカー出力: '300mW',
            チャンネル: '1 ～ 15 チャンネル',
            使用温度: '0℃～ 40℃',
          },
          priceName: `受信スピーカー（F-600）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'コココール',
          imagePath: '/static/products/coco-call/catalogues/catalogue_01.jpg',
          downloadUri: '/static/products/coco-call/catalogues/catalogue_03.pdf',
          pageCount: 2,
          fileType: 'PDF',
          fileSize: '約 2.4MB',
        },
        {
          id: 2,
          name: 'コココール 取り扱い説明書',
          imagePath: '/static/products/coco-call/catalogues/catalogue_02.jpg',
          downloadUri: '/static/products/coco-call/catalogues/catalogue_05.pdf',
          pageCount: 26,
          fileType: 'PDF',
          fileSize: '約 11MB',
        },
      ],
    }
  },
}
</script>

<style scoped>
.feature-section .header h3 {
  color: rgb(16, 106, 203);
  font-size: 1.5em;
}

.feature-section .header h2 {
  color: rgb(16, 106, 203);
}

.feature-title {
  font-size: 20px;
  font-weight: bold;

  display: inline-block;

  margin: 30px 0 10px;
  padding: 0 25px;

  color: white;
  border-radius: 20px;
  background-color: rgb(16, 106, 203);
}

.sp-product .feature-content {
  margin: 20px 0;
}

.feature-section .main-function {
  background-color: rgb(242, 246, 250);
}

.feature-section .main-function .body {
  width: 90%;
  max-width: 1100px;
}

.feature-section .main-function .body .product-block {
  width: 100%;
  margin: 20px 0;
}

.feature-section .main-function .body .product-block .content-header {
  font-size: 18px;

  margin-bottom: 20px;
}

.feature-section .main-function .body .functions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.sp-product .feature-section .main-function .body .functions {
  flex-direction: column;
}

.feature-section .main-function .body .functions .function {
  width: 45%;
  margin-bottom: 10px;

  border: none;
}

.sp-product .feature-section .main-function .body .functions .function {
  width: 100%;
}

.function .function-title {
  padding-bottom: 5px;

  border-bottom: 1px solid rgb(178, 194, 201);
}

.feature-section .main-function .body .vertical-functions {
  display: inline-block;

  width: 80%;
}

.feature-section .main-function .body .vertical-functions .function {
  margin-bottom: 10px;

  border: none;
}

.worries-column .use-scene-block .use-scene-block-header {
  border-left: 4px solid rgb(16, 106, 203);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/CocoCall.vue